<script lang="ts">
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import { params } from "@roxi/routify";

  const distributorName = $params.distributor;
  const goToLogin = () => {
    window.location.href = "/users/sign_in";
  };

</script>

<FizzStyles>
  <div class="fizz-inset-vertical-16" />
  <div class="fizz-flex-row fizz-justify-center fizz-stack-32 fizz-inset-square-16">
    <div
      class="fizz-card fizz-bordered"
      class:fizz-half-width={$LayoutStore.isDesktop}
      class:fizz-inset-square-32={$LayoutStore.isDesktop}
      class:fizz-full-width={$LayoutStore.isMobile}
      class:fizz-inset-square-16={$LayoutStore.isMobile}
    >
      <div class="fizz-flex-row fizz-stack-16">
        <Icon type="CheckCircle" height="30" width="30" extraClassNames="fizz-text-deal" />
        <p class="fizz-heading-3">Application submitted</p>
      </div>
      <p class="fizz-text-medium fizz-stack-16">
        Your application for {distributorName} is complete and has been submitted to the distributor.
      </p>
      <p class="fizz-text-medium">
        The distributor will review your application and assign you a sales rep upon approval.
      </p>
    </div>
  </div>
  <div class="fizz-flex-row fizz-justify-center fizz-stack-16">
    <p class="fizz-text-strong">Manage your distributor account applications</p>
  </div>
  <div class="fizz-flex-row fizz-justify-center">
    <button class="fizz-button-secondary" data-testid="body-login" on:click={goToLogin}>
      Log in
    </button>
  </div>
</FizzStyles>
